import {
  AgentEInvoiceSearchParams,
  CancelPaymentPayload,
  CancelSubmissionPayload,
  CopySubmissionRequest,
  EpaymentAcknowledgePayload,
  ESubmissionAgentSearchParams,
  ESubmissionSearchParams,
  OutstandingViewRequest,
  PaymentEnquirySearchParams,
  ProceedForPaymentPayload,
  SubmissionEnquirySearchParams,
  SubmitPaymentPayload,
  SummaryPaymentRequest,
  SummarySearchRequest,
  TaxInvoiceStatementSearchParams,
  VerifySubmissionPayload,
} from "./e-submission.interface";

const PREFIX = "E_SUBMISSION";

export class GET_SUBMISSIONS_LIST {
  public static readonly type = `[${PREFIX}] GET SUBMISSIONS LIST`;
  constructor(public readonly payload: ESubmissionSearchParams) {}
}

export class RESET_SUBMISSIONS_LIST {
  public static readonly type = `[${PREFIX}] RESET SUBMISSIONS LIST`;
}

export class GET_AGENTS_LIST {
  public static readonly type = `[${PREFIX}] GET AGENTS LIST`;
  constructor(public readonly payload: ESubmissionAgentSearchParams) {}
}

export class RESET_AGENTS_LIST {
  public static readonly type = `[${PREFIX}] RESET AGENTS LIST`;
}

export class GET_ESUBMISSION_PRODUCT_TYPES {
  public static readonly type = `[${PREFIX}] GET PRODUCT TYPES`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_SEARCH_BY {
  public static readonly type = `[${PREFIX}] GET SEARCH BY`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_AGENT_E_INVOICE_TYPES {
  public static readonly type = `[${PREFIX}] GET AGENT E-INVOICE TYPES`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_AGENT_E_INVOICE_SEARCH_BY {
  public static readonly type = `[${PREFIX}] GET AGENT E-INVOICE SEARCH BY`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_ENQUIRY_SEARCH_BY {
  public static readonly type = `[${PREFIX}] GET ENQUIRY SEARCH BY`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_CBC_OUTSTANDING_DAYS {
  public static readonly type = `[${PREFIX}] GET CBC OUTSTANDING DAYS`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_SUBMIT_STATUS {
  public static readonly type = `[${PREFIX}] GET SUBMIT STATUS`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_PAYMENT_STATUS {
  public static readonly type = `[${PREFIX}] GET PAYMENT STATUS`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_PAYMENT_ENQUIRY_SEARCH_BY {
  public static readonly type = `[${PREFIX}] GET PAYMENT ENQUIRY SEARCH BY`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_DOCUMENT_TYPE {
  public static readonly type = `[${PREFIX}] GET DOCUMENT TYPE`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_PAYMENT_MODE {
  public static readonly type = `[${PREFIX}] GET PAYMENT MODE`;
  constructor(public readonly userId: string) {}
}

export class GET_ESUBMISSION_BANK_NAMES {
  public static readonly type = `[${PREFIX}] GET BANK NAMES`;
  constructor(public readonly userId: string) {}
}

export class GET_SUBMISSION_ENQUIRY_LIST {
  public static readonly type = `[${PREFIX}] GET SUBMISSION ENQUIRY LIST`;
  constructor(public readonly payload: SubmissionEnquirySearchParams) {}
}

export class RESET_SUBMISSION_ENQUIRY_LIST {
  public static readonly type = `[${PREFIX}] RESET SUBMISSION ENQUIRY LIST`;
}

export class GET_PAYMENT_ENQUIRY_LIST {
  public static readonly type = `[${PREFIX}] GET PAYMENT ENQUIRY LIST`;
  constructor(public readonly payload: PaymentEnquirySearchParams) {}
}

export class RESET_PAYMENT_ENQUIRY_LIST {
  public static readonly type = `[${PREFIX}] RESET PAYMENT ENQUIRY LIST`;
}

export class GET_SUBMISSION_DETAIL {
  public static readonly type = `[${PREFIX}] GET SUBMISSION DETAIL`;
  constructor(public readonly submissionNo: string) {}
}

export class PROCEED_FOR_PAYMENT {
  public static readonly type = `[${PREFIX}] PROCEED FOR PAYMENT`;
  constructor(public readonly payload: ProceedForPaymentPayload) {}
}

export class SUBMIT_PAYMENT {
  public static readonly type = `[${PREFIX}] SUBMIT PAYMENT`;
  constructor(public readonly payload: SubmitPaymentPayload) {}
}

export class GET_OUTSTANDING_VIEW {
  public static readonly type = `[${PREFIX}] GET OUTSTANDING VIEW`;
  constructor(public readonly payload: OutstandingViewRequest) {}
}

export class GET_SUMMARY_SEARCH {
  public static readonly type = `[${PREFIX}] GET SUMMARY SEARCH`;
  constructor(public readonly payload: SummarySearchRequest) {}
}

export class GET_SUMMARY_PAYMENT_ITEMS {
  public static readonly type = `[${PREFIX}] GET SUMMARY PAYMENT ITEMS`;
  constructor(public readonly payload: SummaryPaymentRequest) {}
}

export class GET_AGENT_E_INVOICE_LIST {
  public static readonly type = `[${PREFIX}] GET AGENT E-INVOICE LIST`;
  constructor(public readonly payload: AgentEInvoiceSearchParams) {}
}

export class RESET_AGENT_E_INVOICE_LIST {
  public static readonly type = `[${PREFIX}] RESET AGENT E-INVOICE LIST`;
}

export class GET_TAX_INVOICE_STATEMENT_LIST {
  public static readonly type = `[${PREFIX}] GET TAX INVOICE STATEMENT LIST`;
  constructor(public readonly payload: TaxInvoiceStatementSearchParams) {}
}

export class RESET_TAX_INVOICE_STATEMENT_LIST {
  public static readonly type = `[${PREFIX}] RESET TAX INVOICE STATEMENT LIST`;
}

// ===== Write-side actions =====

export class VERIFY_SUBMISSION {
  public static readonly type = `[${PREFIX}] VERIFY SUBMISSION`;
  constructor(public readonly payload: VerifySubmissionPayload) {}
}

export class SAVE_AS_DRAFT {
  public static readonly type = `[${PREFIX}] SAVE AS DRAFT`;
  constructor(public readonly payload: SubmitPaymentPayload) {}
}

export class CANCEL_SUBMISSION {
  public static readonly type = `[${PREFIX}] CANCEL SUBMISSION`;
  constructor(public readonly payload: CancelSubmissionPayload) {}
}

export class CANCEL_PAYMENT {
  public static readonly type = `[${PREFIX}] CANCEL PAYMENT`;
  constructor(public readonly payload: CancelPaymentPayload) {}
}

export class COPY_SUBMISSION {
  public static readonly type = `[${PREFIX}] COPY SUBMISSION`;
  constructor(public readonly payload: CopySubmissionRequest) {}
}

export class EPAYMENT_ACKNOWLEDGE {
  public static readonly type = `[${PREFIX}] EPAYMENT ACKNOWLEDGE`;
  constructor(public readonly payload: EpaymentAcknowledgePayload) {}
}

// ===== Submission Payment =====

export class GET_PAYMENT_CONFIG {
  public static readonly type = `[${PREFIX}] GET PAYMENT CONFIG`;
}
